<template>
  <div class="question-wrap" ref="questionWrapRef">
    <div class="question-wrap-left" v-if="qaType == '1'">
      <el-scrollbar always>
        <el-menu :default-active="taxActive" @select="menuSelect">
          <el-tooltip :content="title" placement="right">
            <el-text truncated>{{ title }}</el-text>
          </el-tooltip>

          <el-menu-item-group>
            <el-menu-item v-for="(item, index) of taxList" :key="index" :index="item.type">
              <el-text truncated>{{ item.title }}</el-text>
            </el-menu-item>
          </el-menu-item-group>
        </el-menu>
      </el-scrollbar>
    </div>

    <div class="question-wrap-right">
      <div v-if="qaType != '1'" style="display: flex; flex-direction: row-reverse; padding: 5px 10px 5px 0">
        <el-button plain style="margin-left: 15px" @click="emit('save')" type="primary">暂存</el-button>
        <el-button plain type="primary">上传附送资料</el-button>
      </div>
      <el-scrollbar class="el-scrollbar-question-wrap-right" always>
        <component :is="view" ref="viewRef" />
      </el-scrollbar>
    </div>
  </div>
</template>

<script setup>
// 2.填报企业所得税（季度）
import { nextTick, toRaw } from "vue";
import { ElMessage } from "element-plus";
import { cloneDeep } from "lodash";

import tax21 from "./cmp/tax21.vue";
import tax22 from "./cmp/tax22.vue";
import tax23 from "./cmp/tax23.vue";

const props = defineProps({
  qaType: {
    // 页面类型，默认为1即原始的设置题目，通过菜单切题页面。 其他情况为组件名称即： tax21,tax22
    type: String,
    default: "1",
  },
});

watch(
  () => props.qaType,
  (newVal) => {
    if (newVal == "1") {
      return;
    }
    //nextTick(() => {
    menuSelect(newVal);
    //});
  },
  { immediate: true }
);

const emit = defineEmits(["save", "taxSave"]);

const viewRef = ref();
const isDev = ref(import.meta.env.DEV);
const isSet = ref(location.search.includes("isSet=111"));
const title = ref("2.填报企业所得税（季度）");
const taxList = ref([
  {
    title: "2.1企业所得税月（季）度预缴纳税申报表（A类）",
    type: "tax21",
  },
  {
    title: "2.2资产加速折旧、摊销(扣除)优惠明细表",
    type: "tax22",
  },
  {
    title: "2.3居民企业参股外国企业信息报告表",
    type: "tax23",
  },
]);
const taxActive = ref("tax21");
const view = shallowRef(null);
const views = {
  tax21,
  tax22,
  tax23,
};
view.value = views[taxActive.value];

const mode = ref(null);
const taxDataAll = ref({
  tax21: {
    status: 0, // 0 未填写 1 已填写
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(45, 10),
      // 单选数据
      v6x1: {
        value: "",
        // value: "1",
      },

      // 下拉选择数据
      v14x1: {
        value: "",
        // value: "1_1",
      },
      v15x1: {
        value: "",
        // value: "1_1",
      },
      v17x1: {
        value: "",
        // value: "1",
      },
      v18x1: {
        value: "",
        // value: "1",
      },
      v25x1: {
        value: "",
        // value: "1_1",
      },
      v37x2: {
        value: "",
        // value: "0",
      },

      // 税率
      v21x1: {
        value: 0.25,
      },

      // 考题设置数据
      // 考题设置数据 - 数字数据
      v1x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v1x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v1x3: {
        value: 0,
        answer: null,
        score: null,
      },
      v1x4: {
        value: 0,
        answer: null,
        score: null,
      },
      v1x5: {
        value: 0,
        answer: null,
        score: null,
      },
      v1x6: {
        value: 0,
        answer: null,
        score: null,
      },
      v1x7: {
        value: 0,
        answer: null,
        score: null,
      },
      v1x8: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x3: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x4: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x5: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x6: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x7: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x8: {
        value: 0,
        answer: null,
        score: null,
      },
      // 考题设置数据 单选数据
      v3x1: {
        value: "",
        answer: null,
        score: null,
      },
      v3x2: {
        value: "",
        answer: null,
        score: null,
      },
      // 考题设置数据 数字数据
      v7x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v8x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v9x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v24x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v26x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v28x1: {
        value: 0,
        answer: null,
        score: null,
      },

      // 考题设置数据 下拉数据
      v24x1: {
        value: "",
        // value: "1_1",
        answer: null,
        score: null,
      },
    },
  },
  tax22: {
    status: 0, // 0 未填写 1 已填写
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(5, 6),
      // 第2行数组
      v2x1: {
        value: [],
      },
      // 第4行数组
      v4x1: {
        value: [],
      },
    },
  },
  tax23: {
    status: 0, // 0 未填写 1 已填写
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(15, 7),
    },
  },
});
// 初始化
const taxInit = (options = {}) => {
  nextTick(() => {
    try {
      // 合并数据
      mode.value = options.mode;
      if (options.taxDataAll) {
        taxDataAll.value = options.taxDataAll;
      }

      // 当前税表数据
      const taxData = taxDataAll.value[taxActive.value];
      console.log("初始化数据", {
        mode: mode.value,
        taxDataAll: toRaw(taxDataAll.value),
        taxData: toRaw(taxData),
      });
      // 初始化
      viewRef.value.init({
        mode: mode.value,
        taxDataAll: toRaw(taxDataAll.value),
        taxData: toRaw(taxData),
      });
    } catch (e) {
      console.log(e);
    }
  });
};
// 切换税表
const menuSelect = (value) => {
  // 暂存
  if (mode.value == 1) {
    taxSave(1);
  } else {
    taxSave(2);
    emit("taxSave", { showLoading: false });
  }
  taxActive.value = value;
  view.value = views[value];
};
// 合并选项 合并选项操作只做一次
const taxInitOptionsExtendDone = ref(false);
const taxInitOptionsExtend = (options) => {
  if (!taxInitOptionsExtendDone.value) {
    mode.value = options.mode;
    if (options.taxDataAll) {
      taxDataAll.value = options.taxDataAll;
    }

    taxInitOptionsExtendDone.value = true;
  }
};
// 保存
const taxSave = (type = 1) => {
  // type
  // 1 暂存 不更新填写状态 不根据联表映射规则更新其他tax数据 不发送给后端
  // 2 保存 更新填写状态 根据联表映射规则更新其他tax数据 发送给后端
  console.log(`${["临时", "正式"][type - 1]}保存`);
  try {
    const getData = viewRef.value.getData;

    if (typeof getData === "function" && getData()) {
      // 1
      console.log("当前保存表格为", taxActive.value);
      // 2
      const _data = cloneDeep(getData());
      console.log("当前保存表格数据为", _data);
      // 3
      const _taxDataAll = cloneDeep(toRaw(taxDataAll.value));
      console.log("当前所有表格数据为", _taxDataAll);
      // 4
      _taxDataAll[taxActive.value].data = _data;
      console.log("更新当前保存表格数据到所有表格数据", _taxDataAll);

      if (type == 2) {
        // 5
        if (mode.value == 1) {
          _taxDataAll[taxActive.value].status = 1;
        }
        console.log("做题模式下，更新填写状态", _taxDataAll);
        // 6
        if ([1, 2, 5].includes(+mode.value)) {
          // ElMessage.warning("todo 做题模式下，根据联表映射规则更新其他tax数据");
          taxDataAllUpdate(taxActive.value, _taxDataAll);
        }
      }

      // 重新初始化
      taxInit({
        mode: mode.value, // 1 做题 2 设置题目 3 查看结果 4 查看答案
        taxDataAll: _taxDataAll, // 只有新建题目不需要传入taxDataAll 修改题目，做题，查看结果都需要传入
      });

      console.log("最终返回数据", _taxDataAll);
      return _taxDataAll;
    }
  } catch (e) {
    console.log(e);
  }
};

const questionWrapRef = ref();
const setHeight = () => {
  const $el = questionWrapRef.value;
  $el.style.height = `calc(100vh - ${$el.getBoundingClientRect().top}px - 10px)`;
};

onMounted(() => {
  setHeight();
});

// 联表做题逻辑
function taxDataAllUpdate(taxActive, taxDataAll) {
  console.log("做题模式下，根据联表映射规则更新其他tax数据", taxActive, taxDataAll);
}

// 构造数字输入框数据
function createData(x = 10, y = 10) {
  const data = {};
  for (let i = 1; i <= x; i++) {
    for (let j = 1; j <= y; j++) {
      data[`v${i}x${j}`] = {
        value: isSet.value ? +`${i}${j}` : 0,
      };
    }
  }

  return data;
}

defineExpose({
  taxInit,
  taxSave,
});
</script>

<style lang="scss" scoped></style>
